import React from "react";
import { PointsConfigEditor } from "../features/points-config";
import { withRestaurantId } from "../shared/components/layout";

const PointsConfigEditorWithId = withRestaurantId(PointsConfigEditor);

const PointsConfigPage: React.FC = () => {
  return <PointsConfigEditorWithId />;
};

export default PointsConfigPage;
